import {
  Route, UserCheck, Users, Briefcase, Users2, Heart, Sparkles, GraduationCap,
  MoonStar, Plane, Bus, Building2,
} from "lucide-react";
import SEO from "../lib/seo";
import PageHero from "../components/PageHero";
import CtaSection from "../components/CtaSection";
import { Reveal } from "../components/Reveal";
import { useLead } from "../lib/store";

const HERO_IMG =
  "https://images.unsplash.com/photo-1648230122706-4494d7e1a661?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=1800";

const SERVICES = [
  { icon: Route, title: "Land Arrangement", desc: "Paket lengkap di negara tujuan: hotel, transport, guide, makan, tiket, dan itinerary." },
  { icon: UserCheck, title: "Private Trip", desc: "Perjalanan eksklusif untuk keluarga, pasangan, dan sahabat." },
  { icon: Users, title: "Open Trip", desc: "Gabung group dengan jadwal teratur dan harga bersahabat." },
  { icon: Briefcase, title: "Corporate Travel", desc: "Perjalanan bisnis, gathering, dan incentive trip perusahaan." },
  { icon: Users2, title: "Group Tour", desc: "Group besar dengan bus, guide tambahan, dan program khusus." },
  { icon: Building2, title: "Hotel Booking", desc: "Akomodasi terkurasi dari 3 star hingga 5 star di seluruh destinasi." },
  { icon: Plane, title: "Airport Transfer", desc: "Penjemputan dan pengantar bandara yang nyaman dan tepat waktu." },
  { icon: Bus, title: "Transportation", desc: "Private van dan bus full AC dengan driver berpengalaman." },
  { icon: UserCheck, title: "Local Guide", desc: "Guide lokal berbahasa Indonesia/Inggris/Mandarin sesuai kebutuhan." },
  { icon: MoonStar, title: "Halal Food", desc: "Rekomendasi dan pengaturan makanan halal & muslim friendly." },
  { icon: Sparkles, title: "Attraction Ticket", desc: "Tiket objek wisata dan atraksi tanpa antre." },
  { icon: Bus, title: "Bus Rental", desc: "Sewa bus dan van untuk group di negara tujuan." },
];

export default function Services() {
  const { openLead } = useLead();

  return (
    <>
      <SEO
        title="Layanan Perjalanan — One Partner, Complete Travel Solution | Beyond Travel"
        description="Land Arrangement, Private Trip, Open Trip, Corporate Travel, Group Tour, Hotel, Airport Transfer, Bus Rental, Local Guide, Halal Food, dan Attraction Ticket."
      />
      <PageHero
        image={HERO_IMG}
        eyebrow="Our Services"
        title="One Partner, Complete Travel Solution"
        sub="Dari land arrangement hingga bus rental — semua kebutuhan perjalanan Anda dalam satu partner terpercaya."
        crumb="Services"
      />

      <section className="section bg-cream">
        <div className="container-x grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)} className="h-full">
              <button
                onClick={() => openLead({ source: `service:${s.title}` })}
                className="group h-full w-full rounded-3xl bg-white p-6 text-left shadow-crystal card-hover"
                data-testid={`service-card-${s.title.toLowerCase().replace(/ /g, "-")}`}
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-tosca-50 text-tosca-600 transition-all duration-300 group-hover:bg-tosca-600 group-hover:text-gold">
                  <s.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-charcoal">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaSection title="Butuh Layanan Tertentu?" sub="Diskusikan kebutuhan perjalanan Anda — kami siap menyusun solusi terbaiknya." testid="cta-services" />
    </>
  );
}
